/* eslint-disable complexity */
import React, { ReactNode } from 'react'
import classNames from 'classnames'
export type TextVariants =
  | 'overline'
  | 'overline2'
  | 'footnote1'
  | 'footnote2'
  | 'title1'
  | 'title2'
  | 'subtitle1'
  | 'subtitle2'
  | 'subtitle3'
  | 'body1'
  | 'body2'
  | 'body3'
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'large1'
  | 'large2'
  | 'caption'
  | 'link'
  | 'SPL'
  | 'stockCard'
  | 'small1'
  | 'small2'
const overline = 'text-[11px] leading-4'
const overline2 = 'text-[11px] font-medium uppercase tracking-widest'
const footnote1 = 'text-xs leading-[18px]'
const footnote2 = 'text-xs font-medium leading-[18px]'
const caption = 'text-[13px] leading-5'
const title1 = 'font-medium text-[28px] leading-9 tracking-[0.2px]'
const title2 = 'font-semibold text-[28px] leading-9 tracking-[0.2px]'
const subtitle1 = 'font-medium text-sm leading-5'
const subtitle2 = 'font-medium text-base leading-6'
const subtitle3 = 'font-medium text-lg leading-[26px]'
const body1 = 'text-sm leading-5'
const body2 = 'text-base leading-6'
const body3 = 'text-lg leading-[26px]'
const heading1 =
  'text-2xl leading-6 lg:text-34px lg:leading-8 font-medium tracking-[0.2px]'
const heading2 =
  'lg:text-2xl text-xl font-medium lg:leading-8 leading-6 tracking-[0.2px]'
const heading3 = 'text-lg lg:text-xl font-medium leading-[18px] lg:leading-5 '
const large1 = 'text-5xl font-semibold leading-[60px] tracking-[0.2px]'
const large2 = 'text-5xl font-medium leading-[60px] tracking-[-0.8px]'
const link = 'text-link dark:text-dark-bg-link'
const SPL = 'text-[28px] leading-7 lg:text-[40px] lg:leading-10 font-semibold'
const stockCard = 'font-normal text-sm leading-5'
const small1 = 'text-[9px] leading-5'
const small2 = 'text-[9px] font-medium leading-[18px]'
export type TextProps = {
  appearance?: TextVariants
  tag?: keyof JSX.IntrinsicElements
  addClassName?: string
  children: ReactNode
}
const getVariantClass = (appearance: TextVariants) => {
  if (appearance === 'overline') return overline
  if (appearance === 'overline2') return overline2
  if (appearance === 'footnote1') return footnote1
  if (appearance === 'footnote2') return footnote2
  if (appearance === 'caption') return caption
  if (appearance === 'title1') return title1
  if (appearance === 'title2') return title2
  if (appearance === 'subtitle1') return subtitle1
  if (appearance === 'subtitle2') return subtitle2
  if (appearance === 'subtitle3') return subtitle3
  if (appearance === 'body1') return body1
  if (appearance === 'body2') return body2
  if (appearance === 'body3') return body3
  if (appearance === 'heading1') return heading1
  if (appearance === 'heading2') return heading2
  if (appearance === 'large1') return large1
  if (appearance === 'large2') return large2
  if (appearance === 'heading3') return heading3
  if (appearance === 'SPL') return SPL
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (appearance === 'link') return link
  if (appearance === 'stockCard') return stockCard
  if (appearance === 'small1') return small1
  if (appearance === 'small2') return small2
  return body1
}
const Text: React.FunctionComponent<
  TextProps & React.HTMLAttributes<HTMLOrSVGElement>
> = ({
  appearance = 'body1',
  tag: Wrapper = 'p',
  children,
  addClassName,
  ...rest
}) => {
  const className = classNames(getVariantClass(appearance), addClassName)
  return (
    <Wrapper className={className} {...rest}>
      {children}
    </Wrapper>
  )
}
export default Text
